<template>
  <div class="wlx-stu-cul-wrapper">
    <div class="wlx-site-manager-wrapper">
      <!-- <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
        <el-tab-pane label="全部培训活动" name="first"> -->
          <div class="search-input-con">
            <el-form :inline="true" size="small">
              <!-- <el-form-item label="省份：">
                    <el-select v-model="siteId_" clearable placeholder="请选择省份">
                      <el-option v-for="item in SiteList" :key="item.Id" :label="item.SiteTitle" :value="item.Id"></el-option>
                    </el-select>
              </el-form-item>-->
              <el-form-item label="站点：">
                <el-select v-model="siteId_" clearable placeholder="请选择站点" @change="getAttestationList">
                  <el-option
                    v-for="item in SiteList"
                    :key="item.Id"
                    :label="item.SiteTitle"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input v-model="search" size="small" style="width:220px;" placeholder="请输入活动标题"/>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getAttestationList">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="attestationList" style="width: 100%">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="活动标题" prop="Title"></el-table-column>
            <el-table-column label="发布站点" prop="SiteName"></el-table-column>
            <el-table-column label="开始时间" prop="PulishTime"></el-table-column>
            <el-table-column label="结束时间" prop="EndTime"></el-table-column>
            <el-table-column label="内容" prop="ContentText"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="点击查看活动内容" placement="top-start">
                  <el-button
                    @click="lookClick(scope.row)"
                    size="mini"
                    type="primary"
                    icon="el-icon-view"
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="点击报名" placement="top-start">
                  <el-button
                    size="mini"
                    type="primary"
                    icon="wl-icon-baoming"
                    @click="submit(scope.row.Id)"
                    :disabled="scope.row.idSignUp"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div class="u-page-con">
            <el-pagination
              @size-change="dilhandleSizeChange"
              @current-change="dilhandleCurrentChange"
              :current-page="dilpageIndex"
              :page-sizes="[10, 15, 20, 30]"
              :page-size="dilpageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="diltotalCount"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="我报名的活动" name="second">
          <div>
            <div class="search-input-con">
              <el-input v-model="search" size="small" style="width:220px;" placeholder="请输入活动标题"/>
              <el-button
                style="margin-left: 10px;"
                size="small"
                type="primary"
                icon="el-icon-search"
              >搜索</el-button>
            </div>
            <el-table
              :data="enrollList.filter(data => !search || data.Title.toLowerCase().includes(search.toLowerCase()))"
              style="width: 100%">
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="活动标题" prop="Title"></el-table-column>
              <el-table-column label="内容" prop="Title"></el-table-column>
              <el-table-column label="发布站点" prop="SiteName"></el-table-column>
              <el-table-column label="所属省份" prop="SiteName"></el-table-column>
              <el-table-column label="开始时间" prop="DateCreated"></el-table-column>
              <el-table-column label="结束时间" prop="DateCreated"></el-table-column>
              <el-table-column label="报名时间" prop="DateCreated"></el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.IsAdop==0">等待处理</div>
                  <div v-if="scope.row.IsAdop==1">已通过</div>
                  <div v-if="scope.row.IsAdop==2">未通过</div>
                </template>
              </el-table-column>
            </el-table>
            <div class="u-page-con">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[10, 15, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>
    <el-dialog
      title="活动内容"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="active-content-text">
        <p v-html="content"></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="完善信息"
      :visible.sync="dilog"
      width="50%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <stuInfo :wsxx="true" @closeDilog="closeDilog"></stuInfo>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dilog = false" style="position: absolute;left: 721px;bottom: 20px;">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import stuInfo from "page/xSchool/stuManager/stuInfo.vue";
export default {
  data() {
    return {
      attestationList: [],
      SiteList: [],
      siteId_: "",
      attestationId: "",
      dialogVisible: false,
      enrollList: [],
      search: "",
      pageIndex: 1,
      pageSize: 10,
      totalCount: 10,
      dilpageIndex: 1,
      dilpageSize: 10,
      diltotalCount: 10,
      radio: "",
      tabName: "first",
      content: "",
      dilog:false
    };
  },  
  components: {
    stuInfo
  },
  created() {
    this.getSiteList();
    this.getAttestationStu();
    this.getAttestationList();
  },
  methods: {
	closeDilog(){
      this.dilog = false;
    },
    lookClick(item) {
      this.content = item.Content;
      this.dialogVisible = true;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    dilhandleSizeChange(size) {
      this.dilpageSize = size;
      this.getAttestationList();
    },
    dilhandleCurrentChange(index) {
      this.dilpageIndex = index;
      this.getAttestationList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getAttestationStu();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.getAttestationStu();
    },
    getSiteList() {
      var that = this;
      this.$http.post("/api/XOrg/StudentManager/getSiteList", { type: 4 }).then(function(rst) {
          if (rst.code > 0) {
            that.SiteList = rst.SiteList;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dilog=false;
    },
    siteChange() {
      this.attestationId = "";
      this.getAttestationList();
    },
    getAttestationList() {
      var that = this;
      this.$http.post("/api/XOrg/StudentManager/getAttestationList", {
          SiteId: that.siteId_,
          type: 4,
          page: that.pageIndex,
          Title:that.search,
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.attestationList = rst.attestationList;
            that.dilpageIndex = rst.pagination.pageIndex;
            that.dilpageSize = rst.pagination.pageSize;
            that.diltotalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    submit(Id) {
      var that = this;
      this.attestationId = Id;
      this.$http.post("/api/XOrg/StudentManager/addAttestationStu", {
          attestationId: this.attestationId,
          type: 4
        }).then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getAttestationStu();
            that.getAttestationList();
          } else if(rst.code==-2){
            that.$message.warning(rst.msg);
            that.dilog=true;
          }else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getAttestationStu() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getAttestationStu", {
          type: 4,
          page: this.pageIndex
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.enrollList = rst.enrollList;
            that.pageIndex = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-stu-cul-wrapper {
  .search-input-con {
    padding: 10px;
    background: #fff;
    text-align: right;
    border-bottom: 1px solid #e7ecf4;
  }
  .sign-up-btn {
    margin: 13px 62px 0 0;
  }
}
</style>